module.exports = __webpack_public_path__ + "img/email-primary.d165a2c.svg";